import canUseDOM from "../canUseDOM";
const _requestIdleCallback = function(cb, options) {
  return setTimeout(() => {
    const start = Date.now();
    cb({
      didTimeout: false,
      timeRemaining() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
};
const _cancelIdleCallback = function(id) {
  clearTimeout(id);
};
const isSupported = canUseDOM && typeof window.requestIdleCallback !== "undefined";
const requestIdleCallback = isSupported ? window.requestIdleCallback : _requestIdleCallback;
const cancelIdleCallback = isSupported ? window.cancelIdleCallback : _cancelIdleCallback;
var requestIdleCallback_default = requestIdleCallback;
export {
  cancelIdleCallback,
  requestIdleCallback_default as default
};
//# sourceMappingURL=index.js.map
